import { Box, Chip, Typography } from '@mui/material';

type ProviderChipProps = {
  provider?: string;
  label: string;
};

export function ProviderChip({ provider, label }: ProviderChipProps) {
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 2 }}>
      <Chip
        label={provider?.toUpperCase() || 'SMS PROVIDER'}
        color="primary"
        variant="filled"
        size="small"
      />
      <Typography variant="body2" color="text.secondary">
        {label}
      </Typography>
    </Box>
  );
}
